@include host-component-properties;

:host {
  --paf-result-legend-title-font-weight: var(--paf-global-font-weight-bold);
  --paf-result-legend-title-font-size: 18;
  --paf-result-legend-list-margin-block: 16;
  --paf-result-legend-info-margin-block: 24;
  --paf-result-legend-text-color: var(--paf-global-post-brand-black);
  --paf-result-legend-line-height: 24;
  --paf-result-legend-root-margin-block-large: 32;
  --paf-result-legend-root-margin-block-small: 24;
  --paf-result-legend-root-margin-inline-xlarge: 100;
  --paf-result-legend-root-margin-inline-large: 80;
  --paf-result-legend-root-margin-inline-medium: 60;
  --paf-result-legend-root-margin-inline-small: 16;
}

.legend {
  margin: px-to-rem(var(--paf-result-legend-root-margin-block-small)) px-to-rem(var(--paf-result-legend-root-margin-inline-small));

  @include mq($from: medium) {
    margin-inline: px-to-rem(var(--paf-result-legend-root-margin-inline-medium));
  }

  @include mq($from: large) {
    margin-inline: px-to-rem(var(--paf-result-legend-root-margin-inline-large));
    margin-block: px-to-rem(var(--paf-result-legend-root-margin-block-large));
  }

  @include mq($from: wide) {
    margin-inline: px-to-rem(var(--paf-result-legend-root-margin-inline-xlarge));
  }

  .title {
    font-size: px-to-rem(var(--paf-result-legend-title-font-size));
    margin: 0;
  }

  .list {
    margin: px-to-rem(var(--paf-result-legend-list-margin-block)) 0;
    padding: 0;
  }

  .info {
    margin-block: px-to-rem(var(--paf-result-legend-info-margin-block)) 0;
    line-height: px-to-rem(var(--paf-result-legend-line-height));

    & > * {
      color: var(--paf-result-legend-text-color);
    }
  }
}
